import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 sm:grid-cols-2 mx-x3 sm:m-0 md:mx-x8 gap-x-x2 md:gap-x-x8 gap-y-x4" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "mt-x1 mb-x3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "mb-x3"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "mb-x3"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "text-left" }

import { ref } from 'vue';
import { LocationClientService, StoreModel } from '@/types/locationServerApi';
import OutletOpeningHours from '@/shared/product/details/ui/outlet/OutletOpeningHours.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutletStoreInfo',
  props: {
    storeId: null
  },
  setup(__props: any) {

const props = __props as {
    storeId?: string;
}



const store = ref<StoreModel | null>(null);

if (props.storeId) {
    LocationClientService.getStoreById(props.storeId).then((response) => {
        if (response.model) {
            store.value = response.model;
        }
    });
}

const blockLabels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", null, _toDisplayString(_unref(blockLabels).address), 1),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(store.value?.street), 1),
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(store.value?.zipCode) + " " + _toDisplayString(store.value?.city), 1)
      ]),
      (store.value?.email)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createElementVNode("a", {
              href: `mailto:${store.value?.email}`
            }, _toDisplayString(store.value?.email), 9, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      (store.value?.email)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _createElementVNode("a", {
              href: `tel:${store.value?.phone}`
            }, _toDisplayString(store.value?.phone), 9, _hoisted_8)
          ]))
        : _createCommentVNode("", true),
      (store.value?.salesManager?.name)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(blockLabels).storeManager) + ": " + _toDisplayString(store.value?.salesManager?.name), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (store.value?.openingHours)
        ? (_openBlock(), _createBlock(OutletOpeningHours, {
            key: 0,
            "opening-hours": store.value?.openingHours
          }, null, 8, ["opening-hours"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})